export function NoCheckInsMessage({
  customMessage,
}: {
  customMessage?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center w-full p-6 text-center border border-dashed border-gray-300 rounded-lg bg-surface-0">
      <p className="text-gray-500 text-sm">
        {customMessage ||
          `No Check-in's yet. Check-in on task you worked on today.`}
      </p>
    </div>
  );
}
